module.exports = __webpack_public_path__ + "assets/img/btn-back-4e332028.png";